// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2CB8Icl","text":"_1c7YnTu","searchTerm":"vp-JnyG"};